import { render, staticRenderFns } from "./AvatarImage.vue?vue&type=template&id=1a0d17c7&scoped=true&"
import script from "./AvatarImage.vue?vue&type=script&lang=js&"
export * from "./AvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./AvatarImage.vue?vue&type=style&index=0&id=1a0d17c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d17c7",
  null
  
)

export default component.exports